import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgDuurzaam = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="m24.242 29.548-.145.184-.006-.005a8.837 8.837 0 0 1-13.83-10.976l-.007-.005.061-.07a9 9 0 0 1 1.856-1.853c5-4.442 11.704-6.546 16.407-7.569 1.459 5.855.614 13.478-3.863 19.663a9 9 0 0 1-.473.631"
      clipRule="evenodd"
    />
    <rect
      width={1.156}
      height={16.305}
      x={23.701}
      y={14.919}
      fill="#00C5F2"
      rx={0.5}
      transform="rotate(37.273 23.7 14.919)"
    />
    <path
      fill="#85E3F9"
      d="m11.456 29.472 1.566 1.243-1.72 2.168-1.567-1.243z"
    />
    <rect
      width={1.132}
      height={3.91}
      x={24.913}
      y={18.35}
      fill="#00C5F2"
      rx={0.5}
      transform="rotate(88.362 24.913 18.35)"
    />
    <rect
      width={1.132}
      height={4.181}
      fill="#00C5F2"
      rx={0.5}
      transform="scale(-1 1)rotate(11.487 -85.62 -95.32)"
    />
    <rect
      width={1.132}
      height={5.33}
      x={23.976}
      y={21.406}
      fill="#00C5F2"
      rx={0.5}
      transform="rotate(88.362 23.976 21.406)"
    />
    <rect
      width={1.132}
      height={5.329}
      fill="#00C5F2"
      rx={0.5}
      transform="scale(-1 1)rotate(11.487 -93.17 -81.443)"
    />
    <rect
      width={1.132}
      height={6.64}
      fill="#00C5F2"
      rx={0.5}
      transform="scale(-1 1)rotate(11.487 -100.721 -67.565)"
    />
    <rect
      width={1.132}
      height={6.64}
      x={22.829}
      y={24.304}
      fill="#00C5F2"
      rx={0.5}
      transform="rotate(86.034 22.83 24.304)"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgDuurzaam);

export default ForwardRef;
